'use strict';

/**
 *
 * Form validation - success/error/redirect/or just message
 * jQuery dependency needed
 * HTML: onsubmit="return XXX._form(this);" and loading layer inside form <div class="loading"></div>
 */

var UTILS = UTILS || {};

const trackFormSubmission = ({
    eventName,
    eventCategory,
    eventAction,
    eventLabel,
    eventValue,
    conversionId,
    conversionLabel
}) => {
    if (window.dataLayer === undefined) {
        return;
    }

    window.dataLayer.push({
        'event': eventName,
        'event-tracking-category': eventCategory,
        'event-tracking-action': eventAction,
        'event-tracking-label': eventLabel,
        'event-tracking-value': eventValue
    });

    if (conversionId && conversionLabel) {
        window.dataLayer.push({
            'event': 'google-ads-tracking',
            'conversion-id': conversionId,
            'conversion-label': conversionLabel
        });
    }
};

const sendEventTrackingFromForm = (form) => {
    const eventCategory = form.getAttribute('data-ga-event-category');
    const eventAction = form.getAttribute('data-ga-event-action');
    const eventLabel = form.getAttribute('data-ga-event-label');
    const eventValue = form.getAttribute('data-ga-event-value');

    if (!eventCategory && !eventAction && !eventLabel) {
        return;
    }

    trackFormSubmission({
        eventName: 'contact-form-submission',
        eventCategory,
        eventAction,
        eventLabel,
        eventValue
    });
};

UTILS._form = function _form(form, url) {
    let data = $(form).serialize(),
        loading = true;

    // url = '/ajax/contact';

    $(form).find('.loading').fadeIn();
    $(form).find('button[type="submit"]').text('Sending...');

    $.ajax({
        url: url,
        method: 'POST',
        data: data,
        dataType: 'json'
    })
    .then(function(response) {
        $(form).find('button[type="submit"]').text('Submit');
        $(form).find('.loading').fadeOut();

        sendEventTrackingFromForm(form);

        if (response.url) {
            window.location.href = response.url;
        } else {
            $(form).find('.loading').fadeOut();

            if ( $(form).find('.form__response--ok').length === 0 ) {
                $(form).prepend( '<div class="form__response form__response--ok"><p>'+response.message+'</p></div>' );
            } else {
                $('.form__response--ok p').html(response.message);
            }
        }

        // remove error response if exists and reset the form
        $(form).find('.form__response--error').remove();
        $(form)[0].reset();

    }, function(response) {
        let errorMessage = '';

        if (response.status == 422) {
            for (var field in response.responseJSON) {
                if (response.responseJSON.hasOwnProperty(field)) {
                    errorMessage += response.responseJSON[ field ].join('<br>') + '<br>';
                }
            }
        } else if (response.status == 404) {
            errorMessage = 'Page not found - incorrect url.';
        } else if (response.responseJSON.message) {
            errorMessage = response.responseJSON.message;
        }

        if (errorMessage) {
            if ( $(form).find('.form__response--error').length === 0 ) {
                $(form).prepend( '<div class="form__response form__response--error"><p>'+errorMessage+'</p></div>' );
            } else {
                $('.form__response--error p').html(errorMessage);
            }
        }

        // remove success response if exists
        $(form).find('.form__response--ok').remove();

        $(form).find('button[type="submit"]').text('Submit');
        $(form).find('.loading').fadeOut();
    });

    return false;
};
